import { render, staticRenderFns } from "./EventTraceCards.vue?vue&type=template&id=4c4f6460&scoped=true&"
import script from "./EventTraceCards.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EventTraceCards.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./EventTraceCards.vue?vue&type=style&index=0&id=4c4f6460&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4f6460",
  null
  
)

export default component.exports